import Typography from '@mui/material/Typography';

import { ResolvableModeEnum } from '@e-socna/data-layer';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { ResolvableAmount } from '../../ResolvableFields/ResolvableAmount';
import { ResolvableId } from '../../ResolvableFields/ResolvableId';
import { ResolvablePercent } from '../../ResolvableFields/ResolvablePercent';
import { NoPrimaryWrapper } from '../../ResolvableFields/NoPrimaryWrapper';
import { NoSecondaryWrapper } from '../../ResolvableFields/NoSecondaryWrapper';
import type { ResolvableFieldSettings } from '../../ResolvableFields/types/resolvable-field-settings.type';

import type { ServiceUsageCardCmp_ResolvableServiceBaseInterface } from './fragments/resolvable-service.fragment';

export const ResolvableServiceValueInfos = ({
  resolvableFieldSettings: pResolvableFieldSettings,
  value: { discountAmount, discountPercentage, priceExcludingVat, vatId },
}: Readonly<{
  resolvableFieldSettings: Partial<ResolvableFieldSettings>;
  value: NonNullable<
    ServiceUsageCardCmp_ResolvableServiceBaseInterface['value']
  >;
}>) => {
  const { vatsIdMap } = useReferencesContext();

  const { enableDirectGeneration, primaryMode } = pResolvableFieldSettings;

  const parameters = {
    PrimaryWrapper: NoPrimaryWrapper,
    resolvableFieldSettings: {
      enableDirectGeneration: enableDirectGeneration ?? true,
      primaryMode: primaryMode ?? ResolvableModeEnum.Static,
    },
    SecondaryWrapper: NoSecondaryWrapper,
  };

  return (
    <>
      <Typography gutterBottom variant="body2">
        Montant HT :{' '}
        <ResolvableAmount
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableAmount={priceExcludingVat}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
        />
      </Typography>
      <Typography gutterBottom variant="body2">
        TVA Appliquée :{' '}
        <ResolvableId
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          idMap={vatsIdMap}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
          resolvableId={vatId}
        />
      </Typography>
      <Typography gutterBottom variant="body2">
        Montant Fixe de Remise :{' '}
        {!discountAmount ? (
          'Aucun'
        ) : (
          <ResolvableAmount
            PrimaryWrapper={parameters.PrimaryWrapper}
            SecondaryWrapper={parameters.SecondaryWrapper}
            resolvableAmount={discountAmount}
            resolvableFieldSettings={parameters.resolvableFieldSettings}
          />
        )}
      </Typography>
      <Typography gutterBottom variant="body2">
        Pourcentage de Remise :{' '}
        {!discountPercentage ? (
          'Aucun'
        ) : (
          <ResolvablePercent
            PrimaryWrapper={parameters.PrimaryWrapper}
            SecondaryWrapper={parameters.SecondaryWrapper}
            resolvableFieldSettings={parameters.resolvableFieldSettings}
            resolvablePercent={discountPercentage}
          />
        )}
      </Typography>
    </>
  );
};
